import { IconButton } from '@material-ui/core'
import Collapse from '@material-ui/core/Collapse'
import EditFile from '../EditFile'
import { Edit as EditIcon, Delete as DeleteIcon } from '@material-ui/icons'
import { useState } from 'react'
import '../track.css'

interface Props {
  onDelete: () => void
  setName: (name: string) => void
  setLink: (link: string) => void
  name?: string
  link?: string
  isEditEnable?: boolean
  isNew?: boolean
}

const EditFileCollapse: React.FC<Props> = ({
  onDelete,
  setName,
  setLink,
  name,
  link,
  isEditEnable = false,
  isNew = false
}) => {
  const [isEditing, setIsEditing] = useState(isNew)
  return (
    <>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          width: '100%'
        }}
      >
        {isNew ? (
          <>
            <div className="text_primary">Nuevo Archivo:</div>
            <div
              style={{
                display: 'flex',
                alignItems: 'center'
              }}
            >
              <IconButton
                style={{
                  color: '#ff6900',
                  width: '8px',
                  height: '10px'
                }}
                onClick={onDelete}
              >
                <DeleteIcon style={{ width: '20px' }} />
              </IconButton>
            </div>
          </>
        ) : (
          <>
            <a className="link" href={link} target="_blank" rel="noreferrer">
              {name}
            </a>
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                width: '60px'
              }}
            >
              {isEditEnable ? (
                <>
                  <IconButton
                    style={{
                      color: '#ff6900',
                      width: '8px',
                      height: '10px'
                    }}
                    onClick={() => {
                      setIsEditing(!isEditing)
                    }}
                  >
                    <EditIcon style={{ width: '20px' }} />
                  </IconButton>
                  <IconButton
                    style={{
                      color: '#ff6900',
                      width: '8px',
                      height: '10px'
                    }}
                    onClick={onDelete}
                  >
                    <DeleteIcon style={{ width: '20px' }} />
                  </IconButton>
                </>
              ) : (
                ''
              )}
            </div>
          </>
        )}
      </div>

      <Collapse
        in={isEditing}
        timeout="auto"
        unmountOnExit
        style={{
          width: '100%'
        }}
      >
        <EditFile name={name} link={link} setName={setName} setLink={setLink} isDisabled={false} />
      </Collapse>
    </>
  )
}

export default EditFileCollapse
